import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { FaCopy } from "../../../util/reactIcons";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { ExplorerName, StudyItemWrapper } from "./styled/StyledExplorer";
import { checkClipboardPermission } from "../../../util/clipboardUtils";

const Icon = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-self: flex-start;
  color: ${(props) => props.theme.colors.gray800};
  /* overflow: hidden; */
  z-index: 3;
  p {
    margin: 0 1em;
  }

  :hover {
    svg {
      fill: ${(props) => props.theme.colors.gray600};
    }
  }
`;

const Tooltip = styled.div`
  color: ${(props) => props.theme.colors.gray700};
  padding: 0em 0.5em;
  font-size: 1em;
`;

const SpanText = styled.span`
  color: ${(props) => props.theme.colors.smokeWhite};
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
`;

const StudyItem = ({ study, selected, onClick, currentTab }) => {
	const formattedDate = moment(study.StudyDate).format("DD[/]MM[/]YY");
	const [selection, setSelection] = useState(selected);
	const [numSeries, setNumSeries] = useState();

	const patient = useSelector((state) => state.patient);

	const { t } = useTranslation();

	const copyID = t("tooltip.copyStudyInstanceUID");
	const copySuccess = t("tooltip.copySuccess");
	const notSecure = t("tooltip.notSecure");

	const [tooltipText, setTooltipText] = useState(study.StudyInstanceUID);

	// For multipacs: Checks full studies added to store.patient object, to count its series
	const checkNumSeries = (study) => {
		let fullStudySeries;
		if (patient.studies && Array.isArray(patient.studies)) {
			let fullStudy = patient.studies.find((studyFull) => {
				return studyFull.StudyInstanceUID === study.StudyInstanceUID;
			});

			if (fullStudy && fullStudy.series) {
				fullStudySeries = fullStudy.series.length;
			}
		}
		return (
			fullStudySeries ||
			(study && study.series && study.series.length) ||
			study.NumberOfStudyRelatedSeries
		);
	}; //

	useEffect(() => {
		setSelection(selected);
		setNumSeries(checkNumSeries(study));
	}, [selected, study]);

	const toClipboard = async (e, id) => {
		e.stopPropagation();

		if (!window.isSecureContext) {
			return showNotSecureTooltip();
		}

		try {
			const hasPermission = await checkClipboardPermission();

			if (!hasPermission) {
				return showNotSecureTooltip();
			}

			await navigator.clipboard.writeText(id);
			setTooltipText(copySuccess);
			setTimeout(() => setTooltipText(study.StudyInstanceUID), 2000);
		} catch (err) {
			console.error("Failed to write to clipboard", err);
		}
	};

	const showNotSecureTooltip = () => {
		setTooltipText(notSecure);
		setTimeout(() => setTooltipText(study.StudyInstanceUID), 2000);
	};

	return (
		<StudyItemWrapper
			onClick={onClick}
			selected={selection}
			currentTab={currentTab}
		>
			<Info>
				<SpanText>{study.ModalitiesInStudy}</SpanText>
				<SpanText>{study.StudyDescription}</SpanText>
			</Info>
			{window.isSecureContext && (
				<Icon>
					<FaCopy
						onMouseOver={(e) => {
							e.stopPropagation();
							setTooltipText(copyID);
						}}
						onMouseLeave={(e) => {
							e.stopPropagation();
							tooltipText !== copySuccess
								? setTooltipText(study.StudyInstanceUID)
								: setTimeout(
										() => setTooltipText(study.StudyInstanceUID),
										2000,
									);
						}}
						onClick={(e) => toClipboard(e, study.StudyInstanceUID)}
					/>
					<Tooltip>{tooltipText}</Tooltip>
				</Icon>
			)}

			<SpanText>{formattedDate}</SpanText>
			<ExplorerName>
				Series:
				{numSeries}
			</ExplorerName>
			<ExplorerName />
		</StudyItemWrapper>
	);
};

export default StudyItem;
